<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <PageTitle></PageTitle>
        <b-card>
          <div class="bd-example">
            <dl class="row">
              <dt class="col-sm-3">{{ $t('page.generic.code') }}</dt>
              <dd class="col-sm-9">{{ codingSchemaData.code }}</dd>
              <dt class="col-sm-3">{{ $t('page.generic.version') }}</dt>
              <dd class="col-sm-9">{{ codingSchemaData.codingSchemaVersion }}</dd>
              <dt class="col-sm-3">{{ $t('page.generic.name') }}</dt>
              <dd class="col-sm-9">{{ codingSchemaData.label }}</dd>
              <dt class="col-sm-3">{{ $t('page.generic.description') }}</dt>
              <dd class="col-sm-9">{{ codingSchemaData.description }}</dd>
            </dl>
          </div>
        </b-card>
        <b-card title="DocumentType associate"
                v-if="codingSchemaData.documentTypes && codingSchemaData.documentTypes.length">
          <b-table :stacked="stacked" :dark="dark" :hover="hover" :striped="striped" :bordered="bordered"
                   :small="small"
                   :fixed="fixed"
                   :sortBy="sortBy"
                   responsive="sm" :items="codingSchemaData.documentTypes" :fields="captions"
                   :current-page="currentPage"
                   :per-page="perPage">
            <template slot="description" slot-scope="data">
              <span>{{data.item.description}}</span>
            </template>
          </b-table>
          <nav>
            <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Prev"
                          next-text="Next" hide-goto-end-buttons/>
          </nav>

        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import PageTitle from '@/components/PageTitle'
  import CodingSchemaService from "@/services/CodingSchemaService"
  import miniToastr from 'mini-toastr' //ES6

  const codingSchemaService = CodingSchemaService.build();

  export default {
    name: 'CodingSchemaShow',
    components: {
      PageTitle
    },
    props: {
      id: {
        required: true
      },
      sortBy:{
        type: String,
        default: 'code'
      },
      hover: {
        type: Boolean,
        default: true
      },
      striped: {
        type: Boolean,
        default: false
      },
      stacked: {
        type: String,
        default: 'sm'
      },
      bordered: {
        type: Boolean,
        default: false
      },
      small: {
        type: Boolean,
        default: false
      },
      fixed: {
        type: Boolean,
        default: false
      },
      fields: {
        type: [Array, Object],
        default: () => [
          {key: 'code', label: 'Codice', sortable: true},
          {key: 'label', label: 'Label', sortable: true},
          {key: 'description', label: 'Descrizione', sortable: true}
        ]
      },
      perPage: {
        type: Number,
        default: 10
      },
      dark: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        deleteModal: false,
        codingSchemaData: {},
        currentPage: 1,
      }
    },
    computed: {
      totalRows: function () {
        return this.getRowCount()
      },
      captions: function () {
        return this.fields
      }
    },
    created() {
      miniToastr.init(); // config can be passed here miniToastr.init(config)
      miniToastr.setIcon('error', 'i', {'class': 'fas fa-exclamation-triangle'});
      this.fetchData()
    },
    methods: {
      async fetchData() {
        this.codingSchemaData = await codingSchemaService.read(this.id);
      },
      getRowCount: function () {
        return this.codingSchemaData.documentTypes.length
      }
    }
  }
</script>
